import { UIUtilsEjsVariables } from '../../../shared/scripts/UIUtilsEjsVariables.ts';
import { DiscordContentFrameController } from './content_frame/DiscordContentFrameController.ts';
export class DiscordInstance {
    static getDiscordInstance() {
        if (!UIUtilsEjsVariables.isUserOnDiscord) throw new Error('Not on Discord Activity');
        if (this._discordInstance == undefined) this._discordInstance = new DiscordContentFrameController();
        return this._discordInstance;
    }
}
